/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.SavedSearches";
        /**
         * Component for display of saved searches for the user.
         */
        class ComponentSavedSearch extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._config = null;
                this._componentReady = false;
                this._displayPending = false;
                this._dataList = null;
                // External interaction
                this.SearchSelectedCallBack = null;
                // UI Elements
                this._loader = null;
                this._noRecords = null;
                this._listContainer = null;
                this._removeStyles = ['wpt-font-icon_Trash'];
                // State
                this._searches = null;
                this._storeHtml = (htmlData) => {
                    this._log.info("ComponentSavedSearch._storeHtml()");
                    ComponentSavedSearch.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._requestSearches = () => {
                    this._log.info("ComponentSavedSearch._requestSearches()");
                    this._core.Loader.genericServiceCall('/User.svc/rest/GetSavedSearches', this._displayResult, this._errorCallback, this._failCallback);
                };
                this._displayResult = (response) => {
                    this._log.info("ComponentSavedSearch._displayResult()");
                    this._core.Functions.hideElement(this._loader);
                    this._dataList.clearList();
                    let itemsLength = 0;
                    if (response.hasOwnProperty('SearchDefinitions') && response.SearchDefinitions.length > 0) {
                        this._searches = response.SearchDefinitions;
                        itemsLength = response.SearchDefinitions.length;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got Searches: " + itemsLength);
                        }
                        this._core.Functions.hideElement(this._noRecords);
                        let listData = {
                            Items: []
                        };
                        for (let i = 0; i < itemsLength; i++) {
                            let item = response.SearchDefinitions[i];
                            let itemData = {
                                Id: item.Id,
                                DisplayName: item.Label
                            };
                            let icon = {
                                Classes: [...this._removeStyles],
                                Title: this._core.Locale.getTranslation('STR_WPT_REMOVE_FROM_SAVEDSEARCH'),
                                Callback: this._removeSearch
                            };
                            itemData.SuffixIcons = [icon];
                            listData.Items.push(itemData);
                        }
                        this._dataList.displayData(listData);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got no saved searches");
                        }
                        this._core.Functions.showElement(this._noRecords);
                        this._searches = [];
                    }
                };
                this._searchSelected = (searchId) => {
                    this._log.info("ComponentSavedSearch._searchSelected()");
                    let search = this._searches.find(s => s.Id == searchId);
                    if (!search) {
                        console.warn("Saved Searches Component: Unrecognised search id selected.");
                        return;
                    }
                    this._dataList.clearItemSelection();
                    this._dataList.selectItem(searchId);
                    if (this.SearchSelectedCallBack)
                        this.SearchSelectedCallBack(search);
                };
                this._removeSearch = (searchId, event) => {
                    this._log.info("ComponentSavedSearch._removeSearch()");
                    if (event) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got event");
                        }
                        event.stopPropagation(); // prevent display of document
                    }
                    this._core.Loader.genericServiceCall(`/User.svc/rest/DeleteSavedSearch/${searchId}`, this._searchRemoved, this._errorCallback, this._failCallback);
                };
                this._searchRemoved = (response) => {
                    this._log.info("ComponentSavedSearch._searchRemoved()");
                    this.refresh();
                };
                this.refresh = () => {
                    this._log.info("ComponentSavedSearch.refresh()");
                    if (this._componentReady)
                        this._requestSearches();
                    else
                        this._displayPending = true;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentSavedSearch::constructor");
                this._config = config;
                // But the html is static
                if (!ComponentSavedSearch.Html) {
                    core.Loader.getVersionedHTML('widgets/components/savedsearches.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("ComponentSavedSearch._present()");
                if (!this._readyToPresent) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("not ready - pausing");
                    }
                    this._waitingToPresent = true;
                    return;
                }
                this._container.innerHTML = ComponentSavedSearch.Html;
                this._loader = this._container.querySelector('.wpt-hourglass');
                this._noRecords = this._container.querySelector('#savedSearchNoRecords');
                this._listContainer = this._container.querySelector('#savedSearchListContainer');
                this._core.Helper.prepareHourglassIcon(this._loader);
                // Translations
                this._core.Helper.setElementTranslation(this._container.querySelector('#savedSearchLoading'), 'STR_WPT_LOADING');
                this._core.Helper.setElementTranslation(this._container.querySelector('#savedSearchNoRecordsLabel'), 'STR_WPT_NOINFO');
                // Options
                if (this._config.hasOwnProperty('RemoveButtonIconStyles') && (this._config.RemoveButtonIconStyles != null))
                    this._removeStyles = this._config.RemoveButtonIconStyles;
                let listConfig = {
                    SelectItemCallback: this._searchSelected
                };
                this._dataList = new Widgets.ComponentDataList(this._core, this._listContainer, null, listConfig);
                this._dataList.present();
                // Go!
                this._componentReady = true;
                if (this._displayPending)
                    this._requestSearches();
            }
        }
        ComponentSavedSearch.Html = null;
        Widgets.ComponentSavedSearch = ComponentSavedSearch;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
